<template>
  <li
    :data-tint="availabilityItemReason?.bg_color"
    class="flex flex-col items-start rounded border"
  >
    <div class="flex flex-row items-center">
      <div
        class="bg-primary-300 flex items-center gap-1 border-slate-400 px-1 py-0.5 text-xs font-bold"
      >
        <span>
          {{ localStart.format(localStartFormat) }}
        </span>
        <span v-if="canShowEndDate">
          {{ localEnd.format(localEndFormat) }}
        </span>
        <span v-else>
          {{ $t('attributes.all_day') }}
        </span>
      </div>
      <h5 class="flex-1 px-1 text-xs font-bold">
        {{ availabilityItemReason?.name }}
      </h5>
    </div>
    <p
      v-if="item.remarks"
      class="px-1 text-xs text-slate-500"
      v-html="item.remarks"
    ></p>
  </li>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'AvailabilityItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  emits: [],
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      availabilityItemReasons: 'metadata/getMetadataAvailabilityReasons'
    }),
    availabilityItemReason() {
      return this.availabilityItemReasons.find(
        (availabilityItemReason) =>
          availabilityItemReason.id === this.item.reason
      )
    },
    localStart() {
      return moment(this.item.start_at)
    },
    localStartFormat() {
      if (this.isLocalStartFirstTime) {
        return 'DD/MM/YYYY'
      }

      return 'DD/MM/YYYY HH:mm'
    },
    isLocalStartFirstTime() {
      return this.localStart.format('HH:mm').includes('00:00')
    },
    localEnd() {
      return moment(this.item.end_at)
    },
    localEndFormat() {
      if (this.hasSameDate) {
        return ' - HH:mm'
      } else if (this.isLocalEndLastTime) {
        return ' - DD/MM/YYYY'
      }
      return ' - DD/MM/YYYY HH:mm'
    },
    isLocalEndLastTime() {
      return this.localEnd.format('HH:mm').includes('23:59')
    },
    canShowEndDate() {
      return !(this.hasSameDate && this.isLocalEndLastTime)
    },
    hasSameDate() {
      return (
        this.localStart.format('YYYY-MM-DD') ===
        this.localEnd.format('YYYY-MM-DD')
      )
    }
  },
  methods: {}
}
</script>
